/**
 * Created by yangyue on 2018/7/19.
 */
/**
 * 货币转换
 * @param price
 * @returns {*}
 */
const formattedCurrency = (price) => {
  if (!price) {
    return '';
  }
  return '¥' + (price / 100).toFixed(2);
};

/**
 * 货币格式化
 * 1234500 => ¥12,345.00
 *
 * @param {String} value 要求单位是(分)
 * @param {String} symbol
 * @param {Number} decimals Decimal places
 * @param {Object} options
 */
function currency (value, symbol, decimals, options) {
  let thousandsSeparator;
  let symbolOnLeft;
  let spaceBetweenAmountAndSymbol;
  let digitsRE = /(\d{3})(?=\d)/g;
  options = options || {};
  // 分 转 元
  let _value = parseFloat(value) / 100;
  if (!isFinite(_value) || (!_value && _value !== 0)) {
    return '';
  }
  symbol = symbol != null ? symbol : '';
  decimals = decimals != null ? decimals : 2;
  thousandsSeparator = options.thousandsSeparator != null ? options.thousandsSeparator : ',';
  symbolOnLeft = options.symbolOnLeft != null ? options.symbolOnLeft : true;
  spaceBetweenAmountAndSymbol = options.spaceBetweenAmountAndSymbol != null ? options.spaceBetweenAmountAndSymbol : false;
  let stringified = Math.abs(_value).toFixed(decimals);
  stringified = options.decimalSeparator ? stringified.replace('.', options.decimalSeparator) : stringified;
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  let i = _int.length % 3;
  let head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : '')) : '';
  let _float = decimals ? stringified.slice(-1 - decimals) : '';
  symbol = spaceBetweenAmountAndSymbol ? (symbolOnLeft ? symbol + ' ' : ' ' + symbol) : symbol;
  symbol = (symbolOnLeft
    ? symbol + head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float
    : head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float + symbol);
  let sign = _value < 0 ? '-' : '';
  return sign + symbol;
}

export default {
  formattedCurrency,
  currency
};



// WEBPACK FOOTER //
// ./src/filters/index.js